module.exports = __webpack_public_path__ + "img/login_title2.118dafea.png";